// ---------------------------------------------------------------------------
// Core domain model. Everything the server holds as truth, plus the filtered
// shapes a client is allowed to see.
// ---------------------------------------------------------------------------
export const PHASE_ORDER = ['PLAN', 'ATTACK', 'DEFEND', 'RESOLUTION'];
export function stanceFor(phase, _faction) {
    return phase;
}
//# sourceMappingURL=types.js.map